module.exports = __webpack_public_path__ + "static/media/Arrows Icon.e60a0d8a.jpeg";